import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-[#FAF7F2]" data-id="element-76">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-40 pointer-events-none" data-id="element-77">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-[#E8EDE6] blur-3xl" data-id="element-78"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 rounded-full bg-[#E8EDE6] blur-3xl" data-id="element-79"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 max-w-6xl" data-id="element-80">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-81">
          <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-82">
            <FadeIn data-id="element-83">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2A26] leading-tight mb-6" data-id="element-84">
                ¿Sientes que tu abdomen tiene "vida propia" a partir de las 6 de
                la tarde?
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-85">
              <p className="text-lg md:text-xl text-[#6B6560] mb-8 leading-relaxed" data-id="element-86">
                El método de desinflamación hormonal diseñado para la mujer en
                España que quiere recuperar su ligereza sin pasar hambre ni
                hacer cardio agotador.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-87">
              <Button scrollTo="cta-section" className="w-full md:w-auto" data-id="element-88">
                QUIERO MI PROTOCOLO AHORA
              </Button>
            </FadeIn>
          </div>

          <div className="w-full md:w-1/2 mt-10 md:mt-0 perspective-1000" data-id="element-89">
            <FadeIn delay={0.3} direction="left" data-id="element-90">
              <motion.div initial={{
              rotateY: 15,
              rotateX: 5,
              scale: 0.9
            }} animate={{
              rotateY: -5,
              rotateX: 2,
              scale: 1
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="relative mx-auto max-w-md" data-id="element-91">
                <div className="absolute inset-0 bg-[#4A6741] rounded-2xl blur-2xl opacity-20 transform translate-y-8 scale-95" data-id="element-92"></div>
                <img src="https://cdn.magicpatterns.com/uploads/c1DHJSt7GwzkWNjZTxv2UN/Portada_Protocolo_Vientre_Plano_2B50.png" alt="Protocolo Vientre Plano 50+" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform transition-transform duration-700 hover:scale-[1.02]" data-id="element-93" />
              </motion.div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}